import React from "react";
import './sdInput.scss';

function SDInput (props) {
    return (
        <div className="mainInputBody">
            <div className="block">
                <div className="label">{props.label}</div>
                <div className="inputBG">
                    <input 
                    placeholder={props.placeholder}
                    type={props.type == 'pw' ? 'password' : ''}
                    onChange={e => {props.change(e.target.value)}}></input>
                </div>
            </div>
        </div>
    )
}

export default SDInput;